import React from "react";
import ModalCard from "../../components/ModalCard";
import ModalCardWithHeaderFooter from "../../components/Cards/ModalCardWithHeaderFooter";
import { Box, Grid, Radio, Stack, Typography } from "@mui/material";
import {
  bgColor06,
  blackColor,
  blackShade19,
  blueColor04,
  blueColor06,
  border25,
  greyColor6,
  whiteColor,
} from "../../configs/styles/muiThemes";
import RadiosBtnWithLabel from "../../components/Input/RadiosBtnWithLabel";

function ProductVariantPopup({
  open,
  handleClose,
  handleSubmit,
  value,
  setValue,
  error,
}) {
  return (
    <ModalCard open={open} handleClose={handleClose} width="50%">
      <ModalCardWithHeaderFooter
        title="Add New Product"
        // subTitle="Select Your Product Type"
        onCancel={handleClose}
        onSubmit={handleSubmit}
      >
        <Typography
          fontSize={15.5}
          fontWeight={600}
          color={blackShade19}
          mb={1.5}
        >
          Choose Product Type
        </Typography>
        <Grid container columnSpacing={4}>
          <Grid item md={6}>
            <RadioCard
              url="https://storage.googleapis.com/bodefaults/businessdashboardweb/product-without-variance.svg"
              label="Product (No Variants)"
              checked={value === "no-variant"}
              onValuesChanged={() => setValue("no-variant")}
            />
            <Stack mt={2} gap={1}>
              <Typography
                fontSize={12.5}
                fontWeight={600}
                color={blackShade19}
                lineHeight={1.5}
              >
                Example:
              </Typography>
              <ProductCard
                img="https://storage.googleapis.com/bo3151920215/business/9ffb95f233a54a2e92fe4ffd7887919b/product/58dd9166c4cb44fcb29eba6014f0226e/Product1-508516.png"
                variant1="Bhuira Bitter Orange Marmalade"
              />
            </Stack>
          </Grid>
          <Grid item md={6}>
            <RadioCard
              url="https://storage.googleapis.com/bodefaults/businessdashboardweb/product-with-variance.svg"
              label="Product (With Variants)"
              checked={value === "variant"}
              onValuesChanged={() => setValue("variant")}
            />
            <Stack mt={2} gap={1}>
              <Typography
                fontSize={12.5}
                fontWeight={600}
                color={blackShade19}
                lineHeight={1.5}
              >
                Example:
              </Typography>
              <ProductCard
                img="https://storage.googleapis.com/bo3151920215/business/9ffb95f233a54a2e92fe4ffd7887919b/product/58dd9166c4cb44fcb29eba6014f0226e/Product1-508516.png"
                variant1="Bhuira Apricot Jam 250g"
                variant2="Bhuira Apricot Jam 500g"
              />
            </Stack>
          </Grid>
        </Grid>

        {error && (
          <Typography
            variant="subtitle1"
            component="p"
            fontSize={12}
            fontWeight={500}
            color="red"
            mt="15px"
          >
            {error}
          </Typography>
        )}
      </ModalCardWithHeaderFooter>
    </ModalCard>
  );
}

export default ProductVariantPopup;

const RadioCard = ({ url, label, checked, onValuesChanged }) => {
  return (
    <Box sx={styles.card} onClick={onValuesChanged}>
      <Box position="absolute" top="0" left="0">
        <Radio
          checked={checked}
          size={"large"}
          onChange={() => {
            onValuesChanged();
          }}
          sx={{
            color: blueColor04,
            "&.Mui-checked": {
              color: blueColor04,
            },
          }}
        />
      </Box>
      <Box sx={styles.imgCard}>
        <Box component="img" src={url} width="auto" height="65px" />
      </Box>
      <Typography fontSize={14} fontWeight={600} color={blackColor} mb={0.8}>
        {label}
      </Typography>
    </Box>
  );
};

const ProductCard = ({ img, variant1, variant2 }) => {
  return (
    <Box display="flex" alignItems="center" gap="10px">
      <Box
        component="img"
        src={img}
        width="45px"
        height="45px"
        sx={{ borderRadius: "7px", border: border25, p: "5px" }}
      />
      <Stack gap="4px">
        <Typography
          fontSize={12.5}
          fontWeight={600}
          color={blackShade19}
          lineHeight={1.5}
        >
          {variant1}
        </Typography>
        <Typography
          fontSize={12.5}
          fontWeight={600}
          color={blackShade19}
          lineHeight={1.5}
        >
          {variant2}
        </Typography>
      </Stack>
    </Box>
  );
};

const styles = {
  card: {
    width: "100%",
    backgroundColor: bgColor06,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    border: "1px solid " + blueColor06,
    p: "15px",
    gap: "15px",
    borderRadius: "10px",
    cursor: "pointer",

    "&:hover": { border: "1px solid " + blueColor04 },
  },
  imgCard: { backgroundColor: whiteColor, borderRadius: "50%", p: "5px" },
};
